exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-74241c5c] {\n  text-align: center;\n}\n.container h1[data-v-74241c5c] {\n  margin-top: 16px;\n  font-size: 26px;\n}", ""]);

// exports
